import { env } from "./env";

// External-facing constants keep the empty-string shape the Firebase/gtag
// call sites always received; presence gates belong on `env.* === null`.
export const FIREBASE_VAPID_KEY =
  env.firebaseVapidKey === null ? "" : env.firebaseVapidKey;

export const FIREBASE_CONFIG = {
  apiKey: env.firebaseApiKey,
  authDomain: `${env.firebaseProjectId}.firebaseapp.com`,
  projectId: env.firebaseProjectId,
  storageBucket: `${env.firebaseProjectId}.appspot.com`,
  messagingSenderId: env.firebaseMessagingSenderId,
  appId: env.firebaseAppId,
  measurementId:
    env.firebaseMeasurementId === null ? "" : env.firebaseMeasurementId,
};

export const REDIRECT_MEASUREMENT_ID =
  env.redirectMeasurementId === null ? "" : env.redirectMeasurementId;

export const REDIRECT_HOST =
  env.appEnv === "production" ? "s.juisci.com" : "s-staging.juisci.com";
